import Vue from 'vue'
import { EventBus } from "./views/mytextbook/Course";
import * as alert from "./utils/alert";
import * as biz from "./utils/biz";

export default function() {

    window.updateCourseStudyCnt = ()=>{
        EventBus.$emit('updateStudyCnt');
    }

    window.setCourseInfo = (params)=>{
        const courseNo = params;
        EventBus.$emit('setCourseInfo', courseNo);
    }
}
